export default "__VITE_ASSET__ef79108b__"